// extracted by mini-css-extract-plugin
export default {"product-specs":"ProductSpecs_product-specs__vFLad","spec-title":"ProductSpecs_spec-title__Pu5yk","spec-value":"ProductSpecs_spec-value__KUUx7"};